import { useEffect, useState } from "react"
import { faBan, faCheckCircle } from '@fortawesome/free-solid-svg-icons'
import QRCode from "react-qr-code"
import numeral from "numeral"
import BodyClassName from 'react-body-classname'

import ButtonPrimary from 'components/ButtonPrimary'

import api from 'lib/api'
import { discectError } from 'lib/utils'

import styles from "./styles.module.scss"

const PowerPackTransfer = ({ agency, transferId, packageId, onComplete, onClose, setIsLoading, setError }) => {
  const [transferInfo, setTransferInfo] = useState(null)

  const { id: agencyId } = agency

  useEffect(() => {
    const _fetch = async () => {
      setIsLoading(true)
      try {
        const results = await api.inventory.fetchPackageById(agencyId, packageId)
        console.log(results)
        if (results) {
          const { hash } = await api.powers.generatePowerTransferSheet(agencyId, transferId, results)
          setTransferInfo(() => { return { ...results, transferId, hash } })
        }
      } catch(e) {
        setError(discectError(e))
      }
      setIsLoading(false)
    }
    if (transferId && packageId && agencyId) _fetch()
  }, [transferId, packageId, agencyId, setIsLoading, setError])

  const _takeOwnership = async () => {
    setIsLoading(true)
    try {
      const { transferId, hash } = transferInfo
      await api.inventory.takeOwnership(agency.id, transferId, { hash })
      onComplete()
    } catch(e) {
      setError(discectError(e))
    }
    setIsLoading(false)
  }

  if (transferInfo) {
    const { powers, hash } = transferInfo
    
    let distro = {}
    powers.forEach((itm) => {
      distro[itm.bond_value] = distro[itm.bond_value] || 0
      distro[itm.bond_value] += 1
    })
    return (
      <BodyClassName className={styles.modalOpen}>
        <>
          <div className={styles.transferModal}>
            <header>
              <h3>Transfer</h3>
              <p>Please verify the distribution and powers below before pressing Take Ownership.</p>
            </header>
            <div>
              <h5 className="rad">Distribution</h5>
              <div className={styles.review}>
                {Object.keys(distro).map((value, key) => {
                  return (
                    <div key={key} className={styles.review__row}>
                      <div>
                        <div className={styles.distroPod}>
                          <span>{distro[value]}</span>
                          <span>${numeral(value).format('0,0')}</span>
                        </div>
                      </div>
                      <div>
                        <span className={styles.bigTile}>${numeral(value * distro[value]).format('0,0')}</span>
                      </div>
                    </div>
                  )
                })}
              </div>
              <h5 className="rad">Powers</h5>
              <div className={styles.powers__container}>
                <div className={styles.powers}>
                  {powers.sort((a, b) => (a.po_number > b.po_number) ? 1 : -1).map((itm, key) => {
                    return (
                      <div key={`power_${key}`} className={styles.review__row}>
                        <div className={styles.powerPod}>
                          {itm.po_number}
                        </div>
                        <div>
                          <span className={styles.bigTile}>${itm.bond_value}</span>
                        </div>
                      </div>
                    )
                  })}
                </div>
              </div>
            </div>
            <footer className={styles.transferModal__footer}>
              <div className={styles.transferModal__footer__left}>
                <p>I, {agency.employee.nameFirst} {agency.employee.nameLast}, do herby understand I am taking ownership of these powers and are fully responsible for them.</p>
                <div className={styles.transferModal__actions}>
                  <ButtonPrimary small color="grey" icon={faBan} onClick={onClose}>Cancel</ButtonPrimary>
                  <ButtonPrimary small color="navy" icon={faCheckCircle} onClick={_takeOwnership}>Take Ownership</ButtonPrimary>
                </div>
              </div>
              <div style={{ height: "auto", margin: "0 auto", maxWidth: 64, width: "100%" }}>
                <QRCode
                  size={256}
                  style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                  value={hash}
                  viewBox={`0 0 256 256`}
                />
              </div>
            </footer>
          </div>
          <div className={styles.transferModal__mask} onClick={onClose}></div>
        </>
      </BodyClassName>
    )
  }
  return null

}

export default PowerPackTransfer
